// ----------------------------------------------------------------------
// <copyright file='Izenda.BoardListHeader.jsx' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function() {
  var React = require('react');
  var observer = require('mobx-react').observer;
  var classnames = require('classnames');
  var action = require('mobx').action;

  var GridLayout = require('share/components/controls/Izenda.GridLayout');
  var IconMenu = require('share/components/controls/Izenda.IconMenu');
  var DataGridSearch = require('share/components/controls/DataGrid/Izenda.DataGridSearch');
  var DropDown = require('share/components/controls/Izenda.DropDown');
  var localizer = require('share/localization/Izenda.Localizer');
  var UiState = require('logic/Izenda.UiState');

  module.exports = function(constants) {
    var BoardListHeader = React.createClass({
      propTypes: {
        store: React.PropTypes.object,
        isTemplateType: React.PropTypes.bool
      },

      reset: function() {
        var model = this.props.store.items;

        model.setSearchInfo(constants.SEARCH_CRITERIA[0].value, '', constants.SORT_CRITERIA[0].value);
      },

      getInitialState: function() {
        return {
          isDataSearchMinSize: UiState.isMobile
        };
      },

      renderSearchDataGrid: function() {
        var store = this.props.store;
        var model = store.items;
        var isDataSearchMinSize = this.state.isDataSearchMinSize;

        var widthOnMobile = isDataSearchMinSize ? 3 : 12;

        return (
          <GridLayout.Col cols='6' xs={widthOnMobile} className='izenda-BoardListHeader-searchContainer'>
            <IconMenu className='u_marginRight' />
            <DataGridSearch
              options={this.props.isTemplateType ? constants.TEMPLATE_SEARCH_CRITERIA : constants.SEARCH_CRITERIA}
              value={model.searchType}
              searchValue={model.searchText}
              onSearch={this.onSearch}
              onSearchPropertiesChange={this.onSearchPropertiesChange}
              onSizeStateChange={this.onDataGridSearchSizeChange}
              responsive
              ref='gridSearch' />

          </GridLayout.Col>
        );
      },

      renderSortControl: function() {
        var store = this.props.store;
        var SORT_TYPES = constants.SORT_TYPES;
        var model = store.items;
        var isDataSearchMinSize = this.state.isDataSearchMinSize;
        var isVisible = (isDataSearchMinSize || !UiState.isMobile);
        var sortClassName = classnames({
          'icon-sort-name-up': model.sortDir === SORT_TYPES.ASC,
          'icon-sort-name-down': model.sortDir !== SORT_TYPES.ASC
        });
        var classContainer = classnames(
          'text-right form-inline izenda-BoardListHeader-sortContainer',
          {
            'hidden-xs': !isVisible
          }
        );

        return (
          <GridLayout.Col
            cols='6'
            className= {classContainer}
            xs='9'>
            <span>{localizer.getText('COMMON_LABEL_SORT_BY')}</span>
            <DropDown
              options={this.props.isTemplateType ? constants.TEMPLATE_SORT_CRITERIA : constants.SORT_CRITERIA}
              className='u_marginLeftInnerSpace izenda-BoardListHeader-sort'
              labelField='label'
              valueField='value'
              ref='sortBy'
              value={model.sortBy}
              onChange={this.onSortByChange}
              blankOption={false} />
            <div className='izenda-BoardListHeader-iconSort'>
              <span onClick={this.onSortChange} className={sortClassName} />
            </div>
            {!UiState.isMobile && (
              <div className='btn-group pull-right'>
                <button type='button'
                  className='btn btn-icon u-bgLightBlue u_controlSize'
                  aria-label={localizer.getText('COMMON_LABEL_EXPAND')}
                  onClick={function() { store.items.toggleReportExpandAll(true); } }>
                  <span className='icon-expand-all'></span>
                </button>
                <button type='button'
                  className='btn btn-icon u-bgLightBlue u_controlSize'
                  aria-label={localizer.getText('COMMON_LABEL_COLLAPSE')}
                  onClick={function() { store.items.toggleReportExpandAll(false); } }>
                  <span className='icon-collapse-all'></span>
                </button>
              </div>
            )}
          </GridLayout.Col>
        );
      },

      render: function() {
        return (
          <GridLayout className='izenda-BoardListHeader'>
            <GridLayout.Row>
              {this.renderSearchDataGrid()}
              {this.renderSortControl()}
            </GridLayout.Row>
          </GridLayout>
        );
      },

      onSearchPropertiesChange: function(searchType, searchText) {
        var store = this.props.store;
        var model = store.items;
        var sortByComponent = this.refs.sortBy;
        var selectCtrlComponent = sortByComponent.refs.dropdown;
        model.setSearchInfo(searchType, searchText, selectCtrlComponent && selectCtrlComponent.value);
      },

      onSearch: function(searchProperty, searchText) {
        var props = this.props;
        var store = props.store;
        var model = store.items;
        var sortByComponent = this.refs.sortBy;
        var selectCtrlComponent = sortByComponent.refs.dropdown;
        model.setSearchInfo(searchProperty, searchText, selectCtrlComponent && selectCtrlComponent.value);
        store.lazyLoadingSearch(props.isGlobal);
      },

      /**
       * Handle change of sort by
       * @param {Object} e
       */
      onSortByChange: action(function(e) {
        var boardList = this.props.store.items;
        boardList.setSortBy(e.value);
        this.onSearch();
      }),

      onSortChange: function(e) {
        e.preventDefault();
        var SORT_TYPES = constants.SORT_TYPES;
        var store = this.props.store;
        var model = store.items;
        var sortDir = model.sortDir;

        model.setSortDir(sortDir ? reverseSortDirection(sortDir) : SORT_TYPES.DESC);
        this.onSearch();

        function reverseSortDirection(sortDir) {
          return sortDir === SORT_TYPES.DESC ? SORT_TYPES.ASC : SORT_TYPES.DESC;
        }
      },

      onDataGridSearchSizeChange: function(isMinState) {
        this.setState({
          isDataSearchMinSize: isMinState
        });
      }

    });

    return observer(BoardListHeader);
  };
} ();



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.BoardListHeader.jsx